import { useState } from 'react';
import cx from 'classnames';
import dynamic from 'next/dynamic';

import { ArrowDownIcon } from '#app/pages/rutas-y-cursos/helper/icons';

import styles from './index.module.scss';

const Typography = dynamic(() => import('#app/UI/atoms/typography-updated'));

const Dropdown = ({
 list, currentAge, handleSetCurrentAge, type = 'course' 
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const dropdownState = state => setIsOpen(state);

  return (
    <div className={styles.wrapper}>
      {/* Trigger */}
      <div
        className={styles.trigger}
        onClick={() => dropdownState(!isOpen)}
        onMouseLeave={() => dropdownState(false)}
      >
        <Typography tag="tags">{currentAge.text}</Typography>

        <ArrowDownIcon color={type === 'course' ? '#DEA8FF' : '#FFAA7D'} />

        {/* List */}
        {isOpen && (
          <ul className={styles.list}>
            {list.map((age, idx) => {
              const first = age[Object.keys(age)[0]][0];
              const last = age[Object.keys(age)[0]][age[Object.keys(age)[0]].length - 1];

              const text =
                `${first} - ${last}` === '5 - 18' ? 'Ver todas' : `${first} - ${last}`;
              return (
                <li
                  key={idx}
                  className={cx(styles.item, {[styles.item__active]: currentAge.key === Object.keys(age)[0]})}
                  onClick={() =>
                    handleSetCurrentAge({
                      key: Object.keys(age)[0],
                      text
                    })
                  }
                >
                  <Typography
                    className={cx({['font-bold']: currentAge.key === Object.keys(age)[0]})}
                    tag="tags"
                  >
                    {text}
                  </Typography>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
};

export default Dropdown;
